import { HostListener, Input, Directive } from '@angular/core';

export enum FI_SWIPE_DIRECTION {
    Vertical = 1,
    Horizontal = 2,
}

@Directive()
export abstract class FiSwipeBase {
    @Input('fiSwipeThreshold') threshold = 30;

    touchStartEvent: any;
    swipeDirection: FI_SWIPE_DIRECTION;

    @HostListener('touchstart', ['$event'])
    onTouchStart($event: any) {
        this.touchStartEvent = $event;
        this.lastTouchEvent = $event;
        this.swipeDirection = undefined;
    }

    lastTouchEvent: any;

    @HostListener('touchmove', ['$event'])
    onTouchMove($event: any) {
        this.lastTouchEvent = $event;
        if (!this.swipeDirection) {
            this.swipeDirection = detectSwipeDirection(this.touchStartEvent, this.lastTouchEvent);
        }
    }

    @HostListener('touchend')
    onTouchEnd() {
        if (
            this.touchStartEvent &&
            this.touchStartEvent.touches &&
            this.touchStartEvent.touches.length > 0 &&
            this.lastTouchEvent &&
            this.lastTouchEvent.touches &&
            this.lastTouchEvent.touches.length > 0
        ) {
            this._swipeEndCheck();
        }
        this._resetEvents();
    }

    @HostListener('touchcancel')
    onTouchCancel() {
        this._resetEvents();
    }

    protected abstract _swipeEndCheck();

    protected _resetEvents() {
        this.touchStartEvent = undefined;
        this.lastTouchEvent = undefined;
    }
}

function detectSwipeDirection(touchStartEvent: any, lastTouchEvent: any): FI_SWIPE_DIRECTION {
    if (checkTouchEvent(touchStartEvent) && checkTouchEvent(lastTouchEvent)) {
        if (Math.abs(touchStartEvent.touches[0].screenX - lastTouchEvent.touches[0].screenX) >= 10) {
            return FI_SWIPE_DIRECTION.Horizontal;
        }

        if (Math.abs(touchStartEvent.touches[0].screenY - lastTouchEvent.touches[0].screenY) >= 10) {
            return FI_SWIPE_DIRECTION.Vertical;
        }
    }
}

function checkTouchEvent(touchEvent: any) {
    return touchEvent && touchEvent.touches && touchEvent.touches.length > 0;
}
